import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AppLogo from '../components/AppLogo';
import AppTitle from '../components/AppTitle';
import PageLoader from '../components/PageLoader';
import { OtpInput } from 'reactjs-otp-input';
import '../App.css';

import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import _ from 'lodash';

import Auth from '../core/services/auth';
import Back from '../components/backComponent';


function VerifyCode() {
    
    const navigate = useNavigate();

    const { state } = useLocation();
    const { email } = state;

    const [code, setOtp] = useState('');
    const [ loading, setLoading ] = useState(false)

    const handleChange = (code: any) => {
        setOtp(code)

        console.log(code)

        // init a verify post
        if (code.length === 6) {

            const preventDefault = () => {}

            handleSubmit({ preventDefault })
            //
            console.log('Code Submitted');
        }
    };

    const handleSubmit = (event: any) => {
        

        event.preventDefault();
        
        setLoading(true)
        
        console.log(code)

        //  set form data
        const formData = {
            email: email,
            otp: code
        }

        Auth.comfirmResetPassword(formData).then(res => {
            setLoading(false)
  
            console.log(res.data)
              
            toast.success(res.data.message, {
              position: "top-center",
            });
  
            setTimeout(()=>{
              // navigate 
              navigate('/verify-password', { state: { email: email, otp: code } })
            }, 1800)
  
  
          }).catch(err=>{
    
            console.log(err)
    
            setLoading(false)

            // setTimeout(()=>{
            //   // navigate 
            //   navigate('/verify-password', { state: { email: email, otp: code } })
            // }, 1800)

            if (typeof(err.response) !== "undefined") {
                if (err.response.data && _.isArray(err.response.data.error)) {
                    let error = err.response.data.error
                    //
                    for (let index = 0; index < error.length; index++) {
                      const err = error[index];
                      toast.error(err.message, {
                        position: "top-center",
                      });
                    }
                  } else {
                    toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
                      position: "top-center",
                    });
                  }
            }
            
    
          })
        
    
    
    } 

    return (

      <section className='dark:bg-dark h-full'>
          <Back title='Verify'/>
        <div className="flex flex-col items-center justify-center px-6 py-1 mx-auto h-[60vh] ">
            
            <ToastContainer />
            { loading ? <PageLoader /> : '' }
            <AppLogo />
            <AppTitle title={'Verify Reset Code'} description={'Enter password reset code from email'} />

            <div className="w-full md:mt-0 sm:max-w-md xl:p-0 mt-5">
              <div className="p- space-y-4 md:space-y-6 sm:p-8">
                    <form className="space-y-4 md:space-y-5" onSubmit={handleSubmit}>
                      <div className='mb-5'>
                        <OtpInput shouldAutoFocus={true} className='flex mx-2 bg-gray-50 text-gray-900 rounded-lg  focus:ring-grey-600 focus:border-grey-600 block w-full py-1  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'  inputStyle={{background: 'none', width: '2.67rem', height: '3rem'  }} value={code} onChange={handleChange} numInputs={6} separator={''} />
                      </div>
                      <div className='flex flex-col space-y-4 '>
                        <button type="submit" className="w-full rounded-full text-white bg-yellow-800 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium text-sm px-5 py-4 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">Verify</button>
                        
                      </div>
                  </form>
                </div>
            </div>
        </div>
      </section>
    )
}

export default VerifyCode